/** Share in-flight and successful loads, but do not cache a failed request. */
export function retryableLoader<T>(load: () => Promise<T>): () => Promise<T> {
  let pending: Promise<T> | undefined;
  return () => {
    if (!pending) {
      pending = Promise.resolve().then(load).catch((error: unknown) => {
        pending = undefined;
        throw error;
      });
    }
    return pending;
  };
}
